module.exports = __webpack_public_path__ + "static/media/gwc23_spectrum_logo-colour-no_date.9f7f22ee.png";